import { Component, Prop, Vue } from "vue-property-decorator";
import DfContent from "@/vue/domain/content/df-content";
import Utils from "@/vue/infrastructure/utils/helpers";
import { Carousel, Slide } from "vue-carousel-variable-width";
import DfBrand from "@/vue/domain/brand/df-brand";
import DfStore from "@/vue/domain/store/df-store";
const DfLinkButtonComponent = () => Utils.externalComponent2("df-link-button");

export enum DfSectionLinksComponentMode {
  Grid,
  Flex,
}

@Component({
  components: {
    DfLinkButton: DfLinkButtonComponent,
    Carousel,
    Slide,
  },
})
export default class DfSectionLinksComponent extends Vue {
  @Prop({ type: String, default: "flex" })
  mode!: string;

  private readonly POSITION_HEADER_LINK: string = "HEADER_LINK";

  get brand(): DfBrand {
    return this.$store.getters.brand;
  }

  get buttonsCustom(): Array<DfContent> {
    const storeButtons: Array<DfContent> = this.$store.getters.storeContents.filter((content: DfContent) => content.type.code === "BTC");
    const brandButtons: Array<DfContent> = this.$store.getters.brandContents.filter((content: DfContent) => content.type.code === "BTC");

    return this.filterButtonByPosition([...storeButtons, ...brandButtons]).sort((contentA, contentB) => (contentA.priority <= contentB.priority ? 1 : -1));
  }

  get buttonsBTN(): Array<DfContent> {
    const storeButtons: Array<DfContent> = this.$store.getters.storeContents.filter((content: DfContent) => content.type.code === "BTN");
    const brandButtons: Array<DfContent> = this.$store.getters.brandContents.filter((content: DfContent) => content.type.code === "BTN");

    const buttons: Array<DfContent> = this.filterButtonByPosition([...storeButtons, ...brandButtons]).sort((contentA, contentB) => (contentA.priority <= contentB.priority ? 1 : -1));

    return buttons.filter((button: DfContent) => {
      const rule01: boolean = this.brand.alias !== "dpiu-maxidi";
      const rule02: boolean = Utils.getPropertyValue(this.currentStore, Utils.PROPERTY_PRIVATE_AREA_DISABLED, "BOOLEAN", false);
      const rule03: boolean = button.alias !== "everli" && button.alias !== "gift-card";

      return rule01 || !rule02 || rule03;
    });
  }

  get buttons(): Array<DfContent> {
    return this.buttonsCustom.length ? this.buttonsCustom : this.buttonsBTN;
  }

  get currentStore(): DfStore {
    return this.$store.getters.currentStore;
  }

  filterButtonByPosition(buttons: Array<DfContent>): Array<DfContent> {
    return buttons.filter((linkButton: DfContent) => {
      const valueString: string = Utils.getPropertyValue(linkButton, Utils.PROPERTY_POSITION, "STRING");
      const valueList: any = Utils.getPropertyValue(linkButton, Utils.PROPERTY_POSITION, "LIST", null);
      return (valueList == null && (valueString == null || valueString === this.POSITION_HEADER_LINK)) || valueList.key === "ALL" || valueList.key === this.POSITION_HEADER_LINK;
    });
  }

  buttonVisibility(button: DfContent): string {
    return Utils.getPropertyValue(button, Utils.PROPERTY_BUTTON_VISIBILITY, "STRING", "");
  }

  buttonVisibilityClass(button: DfContent): string {
    const cordova: any = (<any>window).cordova || null;
    const buttonVisibility = this.buttonVisibility(button);
    let buttonClass: string = null;

    if (cordova && buttonVisibility === "MOBILE") {
      buttonClass = "";
    } else if (cordova && buttonVisibility === "DESKTOP") {
      buttonClass = "desktop-in-cordova";
    } else {
      buttonClass = buttonVisibility.toLowerCase();
    }

    return buttonClass;
  }
}
